import { Icon, Table, TableContainer } from "@mui/material";
import {
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";

import { rankItem } from "@tanstack/match-sorter-utils";
import MDInput from "components/MDInput";
import MDPagination from "components/MDPagination";
import MDBox from "components/MDBox";
import { useEffect, useMemo, useState } from "react";
import { TableBody_, TableHead_ } from "./components/table";
import { SetPage } from "./components/pagination";

const fuzzyFilter = (row, columnId, value, addMeta) => {
  const itemRank = rankItem(row.getValue(columnId), value);
  addMeta({ itemRank });
  return itemRank.passed;
};

function BasicTable({
  sx = {},
  data: tableData,
  columns: tableColumns,
  enableCustomFilters = false,
  //customFilters = null,
  //setCustomFilters,
  columnFilter = null,
  setColumnFilter = null,
  customComponent = null,
  onFilterRowsChange = null,
  caption = null
}) {
   
  const [columnFilters, setColumnFilters] = useState([]);
  const [sorting, setSorting] = useState([]);
  const data = useMemo(() => tableData, [tableData]);
  const columns = useMemo(() => tableColumns, [tableColumns]);
  const table = useReactTable({
    data,
    columns,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    onColumnFiltersChange: columnFilter === null ? setColumnFilters : setColumnFilter,
    onSortingChange: setSorting,
    state: {
      columnFilters: columnFilter === null ? columnFilters : columnFilter,
      sorting,
    },
  });
  // useEffect(() => {
  //   if (customFilters != null) {
  //     setColumnFilters(customFilters);
  //   }
  //   console.log(customFilters)
  // }, []);
  useEffect(() => {
    if (onFilterRowsChange !== null) {
      onFilterRowsChange(table.getFilteredRowModel().flatRows.map((row) => row.original));
    }
  }, [columnFilters,columnFilter,data]);
  const { pageIndex, pageSize } = table.getState().pagination;
  const { getPageCount, getCanPreviousPage, getCanNextPage, setPageIndex, setPageSize } = table;
  const showTotalEntries = true;
  const totalData = table.getPrePaginationRowModel()?.rows.length;
  const entriesStart = pageIndex === 0 ? pageIndex + 1 : pageIndex * pageSize + 1;
  let entriesEnd;
  if (pageIndex === 0) {
    entriesEnd = pageSize;
  } else if (pageIndex === getPageCount() - 1) {
    entriesEnd = totalData;
  } else {
    entriesEnd = pageSize * (pageIndex + 1);
  }
  const pageOptions = [...Array(getPageCount())].map((x, index) => index);
  const renderPagination = pageOptions.map((x) => (
    <MDPagination
      item
      key={x}
      active={pageIndex === x}
      onClick={() => {
        setPageIndex(x);
      }}
    >
      {x + 1}
    </MDPagination>
  ));
  const customizedPageOptions = pageOptions.map((x) => x + 1);
  const handleInputPagination = ({ target: { value } }) => {
    value > pageOptions.length || value < 0 ? setPageIndex(0) : setPageIndex(Number(value));
  };
  const handleInputPaginationValue = ({ target: { value } }) => {
    setPageIndex(Number(value) - 1);
  };

  const setPageProps = {
    pageSize,
    entriesStart,
    entriesEnd,
    totalData,
    onChange: (e, value) => setPageSize(value, 10),
  };

  const height = table.getRowModel().rows.length === 0 ? "0" : "545px"
  return (
    <>
      <TableContainer sx={{ borderRadius: ".25rem", border: "1px solid #c9c9c9",height:height,backgroundColor:"inherit", ...sx }}>
        {/* <MDBox display="flex" justifyContent="space-between" alignItems="center" padding="1rem 0">
          <SetPage pageSize={pageSize} onChange={(e, value) => setPageSize(value, 10)} />
          {customComponent&&customComponent}
        </MDBox> */}
        <Table stickyHeader>
          <TableHead_ table={table} />
          <TableBody_ table={table} />
        </Table>
         
      </TableContainer>
      {caption !== null && caption}
      <MDBox
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          sx={{background:"white"}}
          p={!showTotalEntries && pageOptions.length === 1 ? 0 : 1.5}
        >
          {showTotalEntries && <SetPage {...setPageProps} />}
          {pageOptions.length > 1 && (
            <MDPagination variant="gradient" color="info">
              {getCanPreviousPage() && (
                <MDPagination item onClick={() => setPageIndex(pageIndex - 1)}>
                  <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
                </MDPagination>
              )}
              {renderPagination.length > 6 ? (
                <MDBox width="5rem" mx={1}>
                  <MDInput
                    inputProps={{ type: "number", min: 1, max: customizedPageOptions.length }}
                    value={customizedPageOptions[pageIndex]}
                    onChange={(handleInputPagination, handleInputPaginationValue)}
                  />
                </MDBox>
              ) : (
                renderPagination
              )}
              {getCanNextPage() && (
                <MDPagination item onClick={() => setPageIndex(pageIndex + 1)}>
                  <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
                </MDPagination>
              )}
            </MDPagination>
          )}
        </MDBox>
    </>
  );
}

export default BasicTable;
